module.exports = __webpack_public_path__ + "img/map-lg.ec4b2479.jpg";